/**
 * メニュー管理
 */
export class MenuManager {
  constructor() {
    this.menuBtn = document.querySelector('#global-menu-button');
    this.globalMenu = document.querySelector('#global-menu');
    this.body = document.body;

    if (!this.menuBtn) return;

    this.registerEvents();
  }

  registerEvents() {
    // メニューボタンクリック時のイベントを登録
    this.menuBtn.addEventListener('click', this.toggleMenu.bind(this));

    // リンククリック時のイベントを登録
    const links = this.globalMenu.querySelectorAll('a');
    links.forEach((link) => {
      let href = link.getAttribute('href');

      // ただの#だった場合は処理をスキップ
      if (href === '#') return;

      // "/"から始まるhrefはスラッシュを削除
      if (href.startsWith('/#')) {
        href = href.slice(1);
      }

      // #で始まり、要素が存在する場合にイベントリスナーを追加
      if (href.startsWith('#') && document.querySelector(href)) {
        link.addEventListener('click', this.toggleMenu.bind(this));
      }
    });
  }

  toggleMenu() {
    this.body.classList.toggle('is-active-global-menu');
  }
}
